// Diagramme: Fadenkreuz und Tooltip, dazu die Ereignisse hinter einem Marker. Das
// Diagramm ist ohne JavaScript vollständig lesbar - dies ergänzt nur das Ablesen
// einzelner Messpunkte. Die verbindliche Ansicht bleibt die Tabelle darunter.
//
// Marker (a.viz-marker, data-marker: Ereignisse als JSON): ein Klick oder Enter zeigt
// sie im Popover ([data-marker-popover]) samt altem und neuem Wortlaut; Escape, der
// Knopf darin oder ein Klick daneben schließt es, der Fokus kehrt zum Marker zurück.
// Ohne JavaScript führt der Marker zur Liste der Ereignisse unter der Kurve.
export default function charts() {
  document.querySelectorAll('[data-chart]').forEach(function (figure) {
    const svg = figure.querySelector('svg');
    const tooltip = figure.querySelector('.viz-tooltip');
    const crosshair = figure.querySelector('.viz-crosshair');
    if (!svg || !tooltip) return;

    function hide() {
      tooltip.hidden = true;
      if (crosshair) crosshair.hidden = true;
    }

    figure.querySelectorAll('.viz-hit').forEach(function (hit) {
      function show(event) {
        let values;
        try {
          values = JSON.parse(hit.dataset.values || '[]');
        } catch (e) {
          return;
        }

        tooltip.innerHTML =
          '<strong></strong>' +
          values.map(function (v) {
            return '<div class="viz-tooltip-row"><span>' +
              '<span class="viz-swatch" style="background:var(--series-' + v.slot + ')"></span>' +
              '</span><b></b></div>';
          }).join('');

        tooltip.querySelector('strong').textContent = hit.dataset.title || '';
        const rows = tooltip.querySelectorAll('.viz-tooltip-row');
        values.forEach(function (v, i) {
          rows[i].querySelector('span').appendChild(document.createTextNode(v.name));
          rows[i].querySelector('b').textContent = v.text;
        });

        const box = figure.getBoundingClientRect();
        const left = Math.min(
          Math.max(event.clientX - box.left + 14, 8),
          box.width - tooltip.offsetWidth - 8
        );
        tooltip.style.left = left + 'px';
        tooltip.style.top = Math.max(8, event.clientY - box.top - 12) + 'px';
        tooltip.hidden = false;

        if (crosshair) {
          const x = hit.dataset.x;
          crosshair.setAttribute('x1', x);
          crosshair.setAttribute('x2', x);
          crosshair.hidden = false;
        }
      }

      hit.addEventListener('mousemove', show);
      hit.addEventListener('mouseenter', show);
    });

    svg.addEventListener('mouseleave', hide);
    figure.addEventListener('mouseleave', hide);

    markers(figure);
  });
}

// Texte der Ereignisse kommen aus den Daten des Themas: nur als textContent einsetzen.
function eventItem(item) {
  const li = document.createElement('li');
  const label = document.createElement('span');
  label.className = 'viz-popover-label';
  label.textContent = item.number + ' · ' + item.label;
  const text = document.createElement('span');
  text.className = 'viz-popover-text';
  text.textContent = item.text;
  li.append(label, text);

  if (Array.isArray(item.diff) && item.diff.length) {
    const diff = document.createElement('span');
    diff.className = 'diff viz-popover-detail';
    item.diff.forEach(function (segment) {
      if (segment.op === 'del' || segment.op === 'ins') {
        const mark = document.createElement(segment.op);
        mark.textContent = segment.text;
        diff.appendChild(mark);
      } else {
        diff.appendChild(document.createTextNode(segment.text));
      }
    });
    li.appendChild(diff);
  } else if (item.detail) {
    const detail = document.createElement('span');
    detail.className = 'viz-popover-detail';
    detail.textContent = item.detail;
    li.appendChild(detail);
  }
  return li;
}

function markers(figure) {
  const popover = figure.querySelector('[data-marker-popover]');
  if (!popover) return;
  const list = popover.querySelector('[data-marker-items]');
  let opener = null;

  function close(returnFocus) {
    if (popover.hidden) return;
    popover.hidden = true;
    if (returnFocus && opener) opener.focus();
    opener = null;
  }

  figure.querySelectorAll('[data-marker]').forEach(function (marker) {
    marker.addEventListener('click', function (event) {
      let items;
      try {
        items = JSON.parse(marker.dataset.marker || '[]');
      } catch (e) {
        return;
      }
      event.preventDefault();
      list.replaceChildren(...items.map(eventItem));
      opener = marker;
      popover.hidden = false;

      // Unter den Marker, innerhalb der Abbildung.
      const box = figure.getBoundingClientRect();
      const at = marker.getBoundingClientRect();
      const left = Math.min(Math.max(at.left - box.left + at.width / 2 - popover.offsetWidth / 2, 0), box.width - popover.offsetWidth);
      popover.style.left = Math.max(0, left) + 'px';
      popover.style.top = (at.top - box.top + 22) + 'px';
      popover.focus();
    });
  });

  popover.querySelector('[data-marker-close]').addEventListener('click', function () { close(true); });
  popover.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      close(true);
    }
  });
  document.addEventListener('click', function (event) {
    if (!popover.hidden && !popover.contains(event.target) && !event.target.closest('[data-marker]')) close(false);
  });
}
